import styled from 'styled-components';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { useRouter } from 'next/router';
import { useDesktop } from 'src/utils/device';
import { APP_IMG } from 'src/constants';
const LineLink = ({ lineContent }) => {
  const router = useRouter();
  const isDesktop = useDesktop();
  return (
    <div id='add-line' className='pt-20'>
      {lineContent && (
        <TextBase>
          {' '}
          {'ติดตามข่าวสารเพิ่มเติมของ '}
          <strong className='text-red-600'>ขอบสนาม</strong>{' '}
        </TextBase>
      )}
      <div>
        <LineLinkStyle
          title='link-line'
          target='_blank'
          rel='noopener noreferrer nofollow'
          href='https://lin.ee/gRe3OTq' //! DATALAYER
          onClick={() =>
            sendDataLayerGlobal({
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              section: 'เพื่มเพื่อน',
              position: isDesktop ? 'ใต้:เนื้อหาที่-3' : 'ใต้:ข่าวที่เกี่ยวข้อง',
              data: {
                block: '1',
                title: 'line',
                heading: 'เพื่มเพื่อน'
              }
            })
          }
        >
          <img src={`${APP_IMG}/images/line-th.png`} alt='logoline' width='100%' height='100%' />
        </LineLinkStyle>
      </div>
    </div>
  );
};

const TextBase = styled.span`
  font-size: ${({ size }) => size || 16}px;
  transition: 0.25s ease all;
  text-transform: capitalize;
  font-weight: 700;
  margin-bottom: 20px;
  color: rgba(0, 0, 28, 0.95);
  strong {
    font-weight: 700;
    font-size: 18px;
    color: #00d647;
  }
  @media (max-width: 480px) {
    margin-bottom: 15px;
  }
`;
const LineLinkStyle = styled.a`
  img {
    margin-top: 10px;
    width: 100%;
    max-width: 200px;
    border-radius: 5px;
    /* min-height: 72px; */
    min-height: auto;
    opacity: 1;
    &:hover {
      opacity: 0.95;
      box-shadow: #00d647 0px 15px 15px -15px;
      /* box-shadow: #00d647 0px 10px 15px, #00d647 0px 5px 10px; */
    }
  }
`;

export default LineLink;
